import React from 'react';
import { Box, Typography } from '@mui/material';
import KitTooltip from '../components/ui/Tooltip';

// Values describe the whole loaded window, even when the chart shows daily intervals.
export default function PlotReturnSummary({ label, percentage, amount, currency = 'USD', color, description }) {
    const hasPercentage = Number.isFinite(percentage);
    const hasAmount = Boolean(currency) && Number.isFinite(amount);
    if (!hasPercentage && !hasAmount) return null;
    const summary = <Box role="group" aria-label={label} tabIndex={description ? 0 : undefined} sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75,
        ml: 'auto', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums', lineHeight: 1 }}>
        <Typography variant="caption" color="text.secondary">{label}</Typography>
        <Box component="span" aria-hidden="true" sx={{ width: 12, height: 3, borderRadius: 1, bgcolor: color }} />
        {hasPercentage && <Typography component="span" sx={{ color, fontSize: '0.875rem', fontWeight: 700 }}>
            {new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2,
                maximumFractionDigits: 2, signDisplay: 'exceptZero' }).format(percentage)}
        </Typography>}
        {hasAmount && <Typography component="span" sx={{ color: hasPercentage ? 'text.secondary' : color,
            fontSize: '0.8125rem', fontWeight: hasPercentage ? 500 : 700 }}>
            {new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 2,
                maximumFractionDigits: 2 }).format(amount)}
        </Typography>}
    </Box>;
    return description ? <KitTooltip content={description}>{summary}</KitTooltip> : summary;
}
